import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type OrderRefund = {
  order_id: number;
  refund_reason: string;
};

export type Refund = {
  refund_id?: number;
  parcel_service_id?: number;
  rental_id?: number;
  order_id?: number;
  shop_order_id?: number;
  refund_reason?: string;
  refund_amount?: number;
  refund_num?: number;
  refund_date?: number;
  refund_status?: string;
  refund_data?: { [key: string]: Record<string, any> };
  refund_cash_bill_info?: { [key: string]: Record<string, any> };
  created_at?: number;
  updated_at?: number;
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Refund
   * --
   */
  getRefunds: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_REFUND, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Refund
   * --
   */
  getRefund: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_REFUND, { refund_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Refund
   * --
   */
  createRefund: async (body: Refund) => {
    try {
      const res = await $http.post(APIConstant.CREATE_REFUND, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Refund
   * --
   */
  updateRefund: async (body: Refund) => {
    try {
      const { refund_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_REFUND, {
        refund_id: refund_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Refund
   * --
   */
  deleteRefund: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_REFUND, {
        refund_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Refund Manual
   * --
   */
  createRefundManual: async (type: string, body: OrderRefund) => {
    try {
      const url =
        type === 'DELIVERY'
          ? APIConstant.DELIVERY_REFUND_MANUAL
          : type === 'SUBSCRIPTION'
          ? APIConstant.SUBSCRIPTION_REFUND_MANUAL
          : APIConstant.RENTAL_REFUND_MANUAL;
      const res = await $http.post(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Refund Order
   * --
   */
  createRefundOrder: async (body: OrderRefund) => {
    try {
      const res = await $http.post(APIConstant.ORDER_REFUND, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Refund Delivery
   * --
   */
  createRefundDelivery: async (body: Refund) => {
    try {
      const res = await $http.post(APIConstant.DELIVERY_REFUND, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Refund Subscription
   * --
   */
  createRefundSubscription: async (body: Refund) => {
    try {
      const res = await $http.post(APIConstant.SUBSCRIPTION_REFUND, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Refund Rental
   * --
   */
  createRefundRental: async (body: Refund) => {
    try {
      const res = await $http.post(APIConstant.RENTAL_REFUND, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Refund Delivery
   * --
   */
  createRefundDeliveryManual: async (body: Refund) => {
    try {
      const res = await $http.post(APIConstant.DELIVERY_REFUND_MANUAL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Refund Subscription
   * --
   */
  createRefundSubscriptionManual: async (body: Refund) => {
    try {
      const res = await $http.post(
        APIConstant.SUBSCRIPTION_REFUND_MANUAL,
        body
      );

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Refund Rental
   * --
   */
  createRefundRentalManual: async (body: Refund) => {
    try {
      const res = await $http.post(APIConstant.RENTAL_REFUND_MANUAL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
